import React from 'react'

function Line({ classN }) {
    return (
        <div className={classN}>
        </div>
    )
}

export default Line
